module.exports = __webpack_public_path__ + "img/KcMark.2f21fc27.jpg";